import { z } from 'zod'

const jsonResponseSchema = z.object({}).passthrough()

export const billingPaymentSourceWriteAddResponseSchema = jsonResponseSchema
export const billingPaymentSourceWritePreflightResponseSchema = jsonResponseSchema
export const billingPaymentSourceWriteDetachResponseSchema = jsonResponseSchema
export const billingPaymentSourceWritePrimaryResponseSchema = jsonResponseSchema

export type BillingPaymentSourceWriteAddResponse = z.infer<typeof billingPaymentSourceWriteAddResponseSchema>
export type BillingPaymentSourceWritePreflightResponse = z.infer<typeof billingPaymentSourceWritePreflightResponseSchema>
export type BillingPaymentSourceWriteDetachResponse = z.infer<typeof billingPaymentSourceWriteDetachResponseSchema>
export type BillingPaymentSourceWritePrimaryResponse = z.infer<typeof billingPaymentSourceWritePrimaryResponseSchema>
